import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/hanken-grotesk';
import '@fontsource-variable/jetbrains-mono';
import './estilos/app.css';
import './i18n';
import { App } from './App';
import { LimiteErro } from './componentes/limite-erro';
import { ProvedorToast } from './componentes/toast';
import { AvisoNovaVersao } from './componentes/nova-versao';
import { ErroRequisicao } from './nucleo/api';
import { instalarVigiaDeFoco, registrarAtividadeDoVigia } from './nucleo/vigia-foco';
import { registrarServiceWorker } from './nucleo/notificacoes/push';
import { instalarLogDeErros } from './nucleo/log-erros';
import { moduloDaRota } from './nucleo/modulos-web';
import { AvisoErroRegistrado } from './componentes/aviso-erro-registrado';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (n, e) => !(e instanceof ErroRequisicao && e.status < 500) && n < 2,
      // Fase 2 (W16): a nova tentativa do 503 respeita o `Retry-After` do servidor (até 30 s); sem ele, o recuo padrão.
      retryDelay: (n, e) => Math.max(e instanceof ErroRequisicao && e.esperaSegundos ? Math.min(e.esperaSegundos, 30) * 1000 : 0, Math.min(1000 * 2 ** n, 30_000)),
    },
  },
});

// Fase 2 (W3): service worker do PWA (push e instalação). Sem cache de página: o deploy publica na hora.
registrarServiceWorker();
// Review r31 visual: o foco que cai no body quando o botão some ou se desabilita volta para perto de onde estava.
instalarVigiaDeFoco();
// Review r34 (robustez M1): o vigia só espera o botão desabilitado voltar com requisição em curso.
registrarAtividadeDoVigia(() => qc.isMutating() + qc.isFetching() > 0);
// CRM novo desenho, lote 0: o erro que a tela pega vai ao log do núcleo (Admin > Logs de erros).
instalarLogDeErros(qc, moduloDaRota);

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        {/* Fase 2 (W39): "Nova versão disponível" na região de avisos, sem sumir sozinho. */}
        <ProvedorToast fixos={<AvisoNovaVersao />}>
          <LimiteErro>
            <App />
          </LimiteErro>
          <AvisoErroRegistrado />
        </ProvedorToast>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
